module.exports = __webpack_public_path__ + "img/wipConnect.31f66607.jpg";